export const PROPERTY_CODE_PATTERN = '[A-Za-z0-9_-]+';
export const CANADIAN_POSTAL_CODE_PATTERN =
  '[ABCEGHJ-NPRSTVXYabceghj-nprstvyx]\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstvyx][ ]?\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstvyx]\\d';
